export default {"src":"/_next/static/media/mobile-contact-empty-state.a8d5be81.svg","height":140,"width":200,"blurWidth":0,"blurHeight":0};